// src/config/searchConfig.ts
import { PROPERTY_OWNER_DETAILS, AUTO_SEARCH_TEXT } from '../constants/textConstants';

export interface SearchSummaryItem {
  label?: string;
  field?: string;
  type?: 'exportButton' | 'emailSelected';
}

export interface SearchColumn {
  label: string;
  field?: string;
  type?: 'actions';
}

export interface ExpandableField {
  label: string;
  field: string;
}

export interface SearchResultConfig {
  summary: SearchSummaryItem[];
  columns: SearchColumn[];
  key?: string;
  text?: string;
  helpText?: string;
  expandable?: {
    fields: ExpandableField[];
  };
}

export interface SearchConfig {
  [role: string]: {
    [searchType: string]: SearchResultConfig | SearchConfig;
  } | SearchResultConfig;
}

export const searchConfig: SearchConfig = {
  auto: {
    external: {
      local: {
        summary: [
          { label: 'State', field: 'state' },
          { label: 'ZIP Code', field: 'zip' },
          { type: 'emailSelected' }
        ],

        columns: [
          { label: 'Vendor', field: 'vendorName' },
          { label: 'Address', field: 'address' },
          { label: 'Approximate Miles', field: 'approximateMiles' },
          { label: 'Phone', field: 'phone' }
        ],

        helpText: '*You are under no obligation to use any particular repair facility. You have the right to have your vehicle repaired at the shop of your choice. Use of a participating repair facility is strictly voluntary.*'

      },
      name: {
        summary: [
          { label: 'Vendor Name', field: 'vendorName' },
          { label: 'State', field: 'state' },
          { type: 'emailSelected' }
        ],
        columns: [
          { label: 'Vendor', field: 'vendorName' },
          { label: 'Address', field: 'address' },
          { label: 'Phone', field: 'phone' }
        ],

        helpText: '*You are under no obligation to use any particular repair facility. You have the right to have your vehicle repaired at the shop of your choice. Use of a participating repair facility is strictly voluntary.*'
      }
    }
  },
  // Add more roles/searchTypes as needed
  property: {
    external: {
      local: {
        summary: [
          { label: 'State', field: 'state' },
          { label: 'ZIP Code', field: 'zip' },
          { type: 'emailSelected' }
        ],
        columns: [
          { label: 'Vendor', field: 'vendorName' },
          { label: 'Address', field: 'address' },
          { label: 'Approx. Miles', field: 'approximateMiles' },
          { label: 'Phone', field: 'phone' },
          { label: 'Specialty', field: 'vendorSpecializations' },
        ],
        helpText: AUTO_SEARCH_TEXT.PROPERTY_DISCLAIMER,
      },
      name: {
        summary: [
          { label: 'State', field: 'state' },
          { label: 'ZIP Code', field: 'zip' },
          { type: 'emailSelected' }
        ],
        columns: [
          { label: 'Vendor', field: 'vendorName' },
          { label: 'Address', field: 'address' },

          { label: 'Phone', field: 'phone' },
          { label: 'Specialty', field: 'vendorSpecializations' }
        ],
        helpText: AUTO_SEARCH_TEXT.PROPERTY_DISCLAIMER,
        expandable: {
          fields: [
            { label: 'Admin Comments', field: 'adminComments' },
            { label: 'Email', field: 'providerContactEmail' },
            { label: 'Phone', field: 'phone' },
            { label: 'Travelers Provider ID', field: 'providerId' }
          ]
        }
      }
    }
  },
};